import React from 'react';
import DashboardLayout from '../../components/DashboardLayout';

const OPTIONS = [
  {
    href: '/admin/data-tools/export',
    title: 'Database Backup',
    description: 'Download a complete, restorable SQL backup of the entire database — structure and data.',
    icon: 'M12 3v12m0 0l-4-4m4 4l4-4M4 17v2a2 2 0 002 2h12a2 2 0 002-2v-2',
    iconWrap: 'bg-indigo-50 text-indigo-600',
  },
  {
    href: '/admin/data-tools/ai-integration',
    title: 'AI Integration Mode',
    description: 'Turn on a temporary key an external AI tool (e.g. Claude) can use to query the database for analysis, and to propose changes across every table.',
    icon: 'M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456z',
    iconWrap: 'bg-purple-50 text-purple-600',
  },
  {
    href: '/admin/data-tools/ai-integration/study-materials',
    title: 'AI Integration — Study Materials',
    description: 'Turn on a temporary key scoped ONLY to Study Materials: create courses, main titles, sub titles, and Tamil/English HTML content. No other table is reachable.',
    icon: 'M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25',
    iconWrap: 'bg-teal-50 text-teal-600',
  },
];

export default function DataTools() {
  return (
    <DashboardLayout title="Database Activity">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Database Activity</h1>
        <p className="mt-1 text-sm text-gray-600">Super admin only.</p>
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {OPTIONS.map((opt) => (
          <a
            key={opt.href}
            href={opt.href}
            className="group rounded-xl border border-gray-200 bg-white p-6 shadow-sm transition hover:border-indigo-200 hover:shadow-md"
          >
            <span className={`inline-flex h-11 w-11 items-center justify-center rounded-full ${opt.iconWrap}`}>
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d={opt.icon} /></svg>
            </span>
            <h2 className="mt-4 text-base font-bold text-gray-900 group-hover:text-indigo-700">{opt.title}</h2>
            <p className="mt-1.5 text-sm text-gray-500">{opt.description}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-indigo-600">
              Open
              <svg className="h-3.5 w-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
            </span>
          </a>
        ))}
      </div>
    </DashboardLayout>
  );
}
